import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('copy-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1 11a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2h-29a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2h29zm5.098-7C42.353 4 44.1 5.844 44.1 8.12v28.834c0 2.275-1.747 4.12-3.902 4.12h-.099L40.1 13a5 5 0 0 0-5-5H10.932l.002-.086C11.036 5.734 12.742 4 14.832 4h25.366zM23.612 34.67H9.954l-.145.008a1.5 1.5 0 0 0 .145 2.993h13.658l.145-.007a1.5 1.5 0 0 0-.145-2.993zm7.805-7.78H9.954l-.145.007a1.5 1.5 0 0 0 .145 2.993h21.463l.145-.007a1.5 1.5 0 0 0-.145-2.993zm0-8.78H9.954l-.145.007a1.5 1.5 0 0 0 .145 2.993h21.463l.145-.007a1.5 1.5 0 0 0-.145-2.993z",
    fill: props.colors[0],
    fillRule: "evenodd"
  }));
});